import SmoothScroll from 'smoothscroll-polyfill';

// kick off the polyfill!
SmoothScroll.polyfill();